
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import shrinkableMenu from '../components/shrinkable-menu/shrinkable-menu.vue';
import tagsPageOpened from '../components/tags-page-opened.vue';
import breadcrumbNav from '../components/breadcrumb-nav.vue';
import fullScreen from '../components/fullscreen.vue';
import lockScreen from '../components/lockscreen/lockscreen.vue';
import notice from '../components/notices/notice.vue';
import Util from '@/lib/util';
import header1 from '@/components/headers/header.vue';
import footer1 from '@/components/footers/footer.vue'
import AbpBase from '../lib/abpbase'
import ChangePassword from './setting/user/change-password.vue'

@Component({
  components: { shrinkableMenu, tagsPageOpened, breadcrumbNav, fullScreen, lockScreen, notice, header1, footer1 }
})
export default class Main extends AbpBase {
  isFullScreen: boolean = false;
  messageCount: string = '0';

  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr
  }
  get menuList() {
    return this.$store.state.app.menuList;
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>;
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }
  get lang() {
    return this.$store.state.app.lang;
  }
  get avatorPath() {
    return localStorage.avatorImgPath;
  }
  get cachePage() {
    return this.$store.state.app.cachePage;
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme;
  }
  get mesCount() {
    return this.$store.state.app.messageCount;
  }
  get menuVisible() {
    return this.$store.state.app.sidebarMenuVisible;
  }

  @Watch('$route')
  routeChange(to: any) {
    // show sidebar default, althongh some pages need to hide it.
    this.$store.commit('app/showSidebarMenu');

    // for breadcrumb nav
    this.$store.commit('app/setCurrentPageName', to.name);
    let pathArr = Util.setCurrentPath(this, to.name);
    if (pathArr.length > 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name);
    }
    this.checkTag(to.name);
    localStorage.currentPageName = to.name;
  }

  @Watch('lang')
  langChange() {
    Util.setCurrentPath(this, this.$route.name as string);
  }

  mounted() {
    this.init();
  }

  created() {
    this.$store.commit('app/setOpenedList');
  }

  init() {
    let pathArr = Util.setCurrentPath(this, this.$route.name as string);
    this.$store.commit('app/updateMenuList');
    if (pathArr.length >= 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name);
    }
    let messageCount = 3;
    this.messageCount = messageCount.toString();
    this.checkTag(this.$route.name);
  }

  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true;
      } else {
        return false;
      }
    });
    if (!openpageHasTag) {
      Util.openNewPage(this, name as string, this.$route.params || {}, this.$route.query || {});
    }
  }

  handleSubmenuChange(val: string) {
  }

  beforePush(name: string) {
    if (name === 'accesstest_index') {
      return false;
    } else {
      return true;
    }
  }

  fullscreenChange(isFullScreen: boolean) {
    // console.log(isFullScreen);
  }
}
